(function () {
  'use strict';

  var routes = window.themeRoutes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------ mobile menu */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var header = toggle.closest('[data-header]');
    if (!header) return;
    var open = header.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ------------------------------------------------------------------ escape closes menu + drawer */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    qsa('[data-header].is-open').forEach(function (header) {
      header.classList.remove('is-open');
      var toggle = qs('[data-menu-toggle]', header);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    closeDrawer();
  });

  /* ------------------------------------------------------------------ auto-submit selects / filters */
  document.addEventListener('change', function (event) {
    var target = event.target;
    var form = target.form || target.closest('[data-filter-form]');
    if (form && form.hasAttribute('data-filter-form')) { form.submit(); return; }
    if (target.hasAttribute && target.hasAttribute('data-auto-submit') && target.form) target.form.submit();
  });

  /* ------------------------------------------------------------------ quantity steppers */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = qs('input[type="number"]', btn.parentNode);
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10);
    input.value = Math.max(parseInt(input.min || '1', 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ cart drawer */
  function cartIsDrawer() { return document.body.dataset.cartType === 'drawer' && !!qs('[data-cart-drawer]'); }

  function openDrawer() {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('drawer-open');
    var close = qs('.drawer__close', drawer);
    if (close) close.focus();
  }

  function closeDrawer() {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('drawer-open');
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshDrawer() {
    var wrapper = document.getElementById('shopify-section-cart-drawer');
    if (!wrapper) return Promise.resolve();
    return fetch(routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var holder = document.createElement('div');
        holder.innerHTML = data['cart-drawer'];
        var fresh = qs('.shopify-section', holder);
        if (fresh) wrapper.innerHTML = fresh.innerHTML;
        var panel = qs('[data-cart-total-count]', wrapper);
        if (panel) updateCartCount(parseInt(panel.dataset.cartTotalCount, 10) || 0);
      });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var cartLink = event.target.closest('[data-cart-link]');
    if (cartLink && cartIsDrawer() && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
      refreshDrawer().then(openDrawer);
      return;
    }

    var change = event.target.closest('[data-cart-change]');
    if (change) {
      event.preventDefault();
      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(change.dataset.line, 10), quantity: parseInt(change.dataset.qty, 10) })
      }).then(function () { return refreshDrawer(); });
    }
  });

  /* AJAX add to cart (drawer mode) */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !cartIsDrawer()) return;
    event.preventDefault();

    var button = qs('[type="submit"]', form);
    if (button) { button.classList.add('is-loading'); button.disabled = true; }

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'Could not add to cart');
        return refreshDrawer().then(openDrawer);
      })
      .catch(function (err) {
        var msg = qs('.form-error', form);
        if (!msg) { msg = document.createElement('p'); msg.className = 'form-error'; msg.setAttribute('role', 'alert'); form.appendChild(msg); }
        msg.textContent = err.message;
      })
      .then(function () {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      });
  });

  /* ------------------------------------------------------------------ product page */
  function initProduct(root) {
    if (root.dataset.ready) return;
    var dataEl = qs('[data-variant-data]', root);
    if (!dataEl) return;
    root.dataset.ready = '1';

    var variants = JSON.parse(dataEl.textContent);
    var idInput = qs('[data-variant-id]', root);
    var button = qs('[data-add-button]', root);
    var priceWrap = qs('[data-price]', root);
    var priceEl = qs('[data-price-current]', root);
    var compareEl = qs('[data-price-compare]', root);
    var skuWrap = qs('[data-sku-wrap]', root);
    var skuEl = qs('[data-sku]', root);
    var stockEl = qs('[data-stock]', root);
    var slides = qsa('[data-slide]', root);
    var thumbs = qsa('[data-thumb]', root);
    var saveEl = qs('[data-price-save]', root);
    var bar = qs('[data-sticky-bar]', root);
    var barBtn = bar ? qs('[data-bar-button]', bar) : null;
    var barPrice = bar ? qs('[data-bar-price]', bar) : null;

    if (bar && button && barBtn && 'IntersectionObserver' in window) {
      barBtn.textContent = button.textContent.trim();
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(button);
    }

    function showSlide(id) {
      var target = String(id);
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === target); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === target); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showSlide(thumb.dataset.mediaId); });
    });

    function selectedOptions() {
      return qsa('[data-option]', root).map(function (fieldset) {
        var checked = qs('input:checked', fieldset);
        return checked ? checked.value : null;
      });
    }

    function stockText(v) {
      if (!v.available) return stockEl.dataset.out;
      if (v.managed && v.stock > 0 && v.stock <= parseInt(stockEl.dataset.threshold, 10)) {
        return stockEl.dataset.low.replace('[count]', v.stock);
      }
      return stockEl.dataset.in;
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (option, i) { return option === chosen[i]; });
      });

      if (!match) {
        if (button) { button.disabled = true; button.textContent = button.dataset.unavailable; }
        if (barBtn && button) { barBtn.disabled = true; barBtn.textContent = button.textContent; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price;
      if (compareEl && priceWrap) {
        if (match.compare) {
          compareEl.innerHTML = match.compare;
          compareEl.hidden = false;
          priceWrap.classList.add('price--sale');
        } else {
          compareEl.hidden = true;
          priceWrap.classList.remove('price--sale');
        }
      }
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? button.dataset.add : button.dataset.soldout;
      }
      if (saveEl) { saveEl.hidden = !match.save; saveEl.textContent = 'Save ' + match.save + '%'; }
      if (barPrice) barPrice.innerHTML = match.price;
      if (barBtn && button) { barBtn.disabled = !match.available; barBtn.textContent = button.textContent.trim(); }
      if (skuEl && skuWrap) { skuEl.textContent = match.sku; skuWrap.hidden = !match.sku; }
      if (stockEl) stockEl.textContent = stockText(match);
      if (match.media) showSlide(match.media);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    qsa('[data-option] input', root).forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  /* ------------------------------------------------------------------ recommendations */
  function initRecommendations(scope) {
    qsa('[data-recommendations][data-url]', scope).forEach(function (el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var fresh = qs('[data-recommendations]', holder);
          if (fresh && fresh.innerHTML.trim().length) { el.innerHTML = fresh.innerHTML; initReveal(el); }
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------ slideshow */
  function initSlideshow(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = qs('[data-track]', root);
    var dots = qsa('[data-dot]', root);
    var slides = track ? track.children : [];
    if (!track || slides.length < 2) return;

    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      var n = slides.length;
      i = (i + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function sync() { var i = index(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }

    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    var prev = qs('[data-prev]', root), next = qs('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); }); });

    var seconds = parseInt(root.dataset.autoplay, 10);
    if (seconds > 0 && !designMode) {
      var timer = setInterval(function () { go(index() + 1); }, seconds * 1000);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  }

  /* ------------------------------------------------------------------ scroll reveal */
  var observer = null;
  function initReveal(scope) {
    var mode = document.body.dataset.animation;
    if (!mode || mode === 'none') return;
    var targets = qsa('main .section .page-width > *, main .card, main .collection-card, main .mc__item, main .quote, main .blog-card', scope || document);
    if (designMode || !('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    targets.forEach(function (el) {
      if (el.classList.contains('reveal') || el.matches('script, style, [data-sticky-bar], .drawer, [hidden]')) return;
      el.classList.add('reveal');
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------ boot */
  function initAll(scope) {
    qsa('[data-product]', scope).forEach(initProduct);
    qsa('[data-slideshow]', scope).forEach(initSlideshow);
    initRecommendations(scope);
    initReveal(scope);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
/* ===== Product gallery: limit thumbnails + arrows + swipe (paste at the very bottom of assets/theme.js) ===== */
(function () {
  var MAX_THUMBS = 5; // how many thumbnails to show; change this number if you like

  function setup(gallery) {
    if (gallery.dataset.limitReady) return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;
    gallery.dataset.limitReady = '1';
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var stacked = gallery.classList.contains('gallery--stacked');
    if (stacked) return;

    /* 1. limit thumbnails */
    var more = null;
    if (thumbs.length > MAX_THUMBS) {
      thumbs.forEach(function (t, i) { if (i >= MAX_THUMBS) t.classList.add('gallery__thumb--hidden'); });
      more = thumbs[MAX_THUMBS - 1];
      more.classList.add('gallery__thumb--more');
      more.setAttribute('data-more', '+' + (thumbs.length - MAX_THUMBS + 1));
      more.setAttribute('aria-label', 'Show more images');
    }

    function current() {
      for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
      return 0;
    }
    function go(i) {
      var n = slides.length;
      i = (i + n) % n;
      var id = slides[i].dataset.mediaId;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === id); });
      sync();
    }
    function sync() {
      var i = current();
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (more) {
        var beyond = i >= MAX_THUMBS - 1;
        more.classList.toggle('is-active', beyond);
        more.classList.toggle('is-open', beyond);
      }
    }

    /* the "+N" thumbnail steps through the hidden images */
    if (more) {
      more.addEventListener('click', function (e) {
        var i = current();
        if (i >= MAX_THUMBS - 1) { e.stopImmediatePropagation(); go(i + 1 < slides.length ? i + 1 : MAX_THUMBS - 1); }
        setTimeout(sync, 0);
      }, true);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setTimeout(sync, 0); }); });

    /* 2. arrows + counter on the main image */
    var nav = document.createElement('div');
    nav.className = 'gallery__nav';
    nav.innerHTML = '<button type="button" class="gallery__arrow gallery__arrow--prev" aria-label="Previous image">&#8249;</button>' +
      '<span class="gallery__count" aria-live="polite"></span>' +
      '<button type="button" class="gallery__arrow gallery__arrow--next" aria-label="Next image">&#8250;</button>';
    gallery.appendChild(nav);
    var counter = nav.querySelector('.gallery__count');
    nav.querySelector('.gallery__arrow--prev').addEventListener('click', function () { go(current() - 1); });
    nav.querySelector('.gallery__arrow--next').addEventListener('click', function () { go(current() + 1); });

    /* 3. swipe on touch screens */
    var startX = null, startY = null;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && !e.target.closest('.gallery__thumbs')) go(current() + (dx < 0 ? 1 : -1));
      startX = null;
    });

    /* keep counter right when a variant switches the image */
    new MutationObserver(sync).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.product__gallery'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
